import DriverAssetIssuanceTrackingApi from "../../services/api/DriverAssetIssuanceTracking";
import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import ErrorMsgs from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";

import { getQueryParams } from "../../utils";

function handleError(err) {
  console.log("Error in DriverAssetIssuanceTracking actions", err);
}

export const setDriverAssetIssuanceTracking = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_ASSET_ISSUANCE_TRACKING_DATA,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_DRIVER_ASSET_ISSUANCE_TRACKING_DATA,
    payload,
  };
};

export const getDriverAssetIssuanceTracking = (fe_id) => async (dispatch) => {
  try {
    const queryParam = {
      "fe-id": fe_id,
    };
    const queryParams = getQueryParams(queryParam);
    dispatch(setLoader(true));
    const response =
      await DriverAssetIssuanceTrackingApi.getDriverAssetIssuance(queryParams);
    if (response) {
      dispatch(setLoader(false));
      dispatch(setDriverAssetIssuanceTracking(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(resetState({ state: "driverAssetIssuanceTrackingData" }));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
